module.exports = __webpack_public_path__ + "img/China_Power_120X35.11fa045c.png";